import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {Solicitar} from './Solicitar';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {SuperiroCategoriasEmpresa} from './SuperiroCategoriasEmpresa';
import {CatServActivos} from './CatServActivos';
import {CatServPendientes} from './CatServPendientes';
import {CatServAñadir} from './CatServAñadir';
import {CatServInactivos} from './CatServInactivos';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { Form, Modal as M } from 'react-bootstrap';
import Dropdown from 'react-dropdown';
import {useNavigate} from 'react-router-dom';
import ToastNotification from '../../hooks/ToastNotification';
import {ModalPerido} from '../RegistroEmpresas/ModalPerido';
import {sumarMinuto} from '../../fuctions/Sumar_Minutos_Horas';
import {sumarUnaHora} from '../../fuctions/Sumar_Minutos_Horas';

export const ContentBodyCategoriaEmpresa = (props) => {
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const {MenuLateralAux, chageMenuLateralAux} = props;
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);

	const [Servicios, setServicios] = useState([]);
	const [Categorias, setCategorias] = useState([]);

	const [ServiciosPendientes, setServiciosPendientes] = useState([]);
	const [CategoriasPendientes, setCategoriasPendientes] = useState([]);

	const [ServiciosInactivo, setServiciosInactivo] = useState([]);
	const [activar, setActivar] = useState(false);
	const [estado, setEstado] = useState('activo');
	const [servicio, setServicio] = useState();
	const [modalActivarDesactivar, setModalActivarDesactivar] = useState(false);

	const [ModalPeriodo, setModalPeriodo] = useState(false);

	const [sedes, setSedes] = useState();
	const [sedeId, setSedeId] = useState();

	const [serviciosSedes, setServiciosSedes] = useState([]);

	const [empresa, setEmpresa] = useState({
		idEmpresa: '-------',
		nombreEmpresa: 'nombreEmpresSa',
		nombreContactoEmpresa: 'nombreContactoEmpresa',
		apellidosContactoEmpresa: 'apellidosContactoEmpresa',
		constraseña: 'constraseña',
		repitaConstraseña: 'repitaConstraseña',
		telefono: '666666666',
		direccion: 'direccion',
		codigoPostal: 'codigoPostal',
		webEmpresa: 'webEmpresa',
		emailEmpresa: 'emailEmpresa',
		tamañoEmpresa: '0',
		shareCare: false,
		descripcionEmpresa: 'descripcionEmpresa',
		notasEmpresa: 'notasEmpresa',
	});

	const navigate = useNavigate();

	const [toastMsg, setToastMsg] = useState('');
	const [showToast, setShowToast] = useState(false);
	const [toastType, setToastType] = useState('success');

	const getDatEmpresa = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			setEmpresa(response.data[0]);
		});
	};

	const get_sedes = () => {
		if (empresa)
			axios({
				method: 'get',
				url: window.ipdirection + 'sedePrestador/?idempresa=' + empresa.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			}).then((response) => {
				setSedes(response.data);
			});
	};

	/* A function that is called when the user clicks on one of 
  the buttons on the top of the page. */
	const cambioNotificaciones = (num) => {
		setServiciosSedes('')
		//setServicioPacientes([])
		let listaAxu = [
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
		];
		listaAxu[num] = 'buttonNotificacionesActive';
		switch (num) {
			case 0:
				get_Servicio_Empresa_Activo();
				get_Categoria_Empresa_Activo();
				break;
			case 1:
				get_Servicio_Empresa_Inactivo();
				break;
			case 1:
				get_Servicio_Empresa_Pendiente();
				get_Categoria_Empresa_Activo();
				get_Categoria_Empresa_Pendiente();
				break;
			default:
				get_Servicio_Empresa_Activo();
				get_Categoria_Empresa_Activo();
				break;
		}
		/* A function that is called when the user clicks 
        on one of the buttons on the top of the page. */
		setTipoNotificaciones(listaAxu);
		//const tipes = ["get_Presupuestos_Hoy", "get_Presupuestos_Pendientes", "get_Presupuestos_Por_Confirmar", "get_Presupuestos_All",]
		//getPresupuestos(tipes[num]);
	};
	const get_Servicio_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServicios([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Categoria_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Categoria_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setCategorias([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Servicio_Empresa_Pendiente = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Pendiente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServiciosPendientes([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Categoria_Empresa_Pendiente = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Categoria_Empresa_Pendiente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let lista = [];
				lista.push(...Categorias);
				lista.push(...response.data);
				setCategoriasPendientes([...lista]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const get_Servicio_Empresa_Inactivo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Inactivo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setServiciosInactivo([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getDatEmpresa();
		get_Categoria_Empresa_Activo();
		get_Servicio_Empresa_Activo();
		// get_Servicio_Empresa_Inactivo();
	}, []);

    useEffect(() => {
        get_sedes()
    },[empresa])

	const seleccionarSede = (sede, estado) => {
		axios({
			method: 'get',
			url:
				window.ipdirection +
				'Servicio_Empresa_SedePrestador_Estado/?sede=' +
				sede +
				'&estado=' +
				estado,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			setServiciosSedes(response.data);
		});
	};

	const activarDesactivarServicios = async () => {
		if (activar) {
			let data = {
				estado: 'activo',
				servicio_id: servicio,
				sede_id: serviciosSedes[0].sede_id,
			};
			axios({
				method: 'put',
				url: window.ipdirection + 'Servicio_Empresa_SedePrestador_Estado/' + servicio + '/',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: data,
			})
				.then((response) => {
					setModalActivarDesactivar(false);
					//get_Servicio_Empresa_Inactivo();
					//setServiciosSedes('');
					seleccionarSede(sedeId, 'inactivo')
					setToastMsg('Servicio activado correctamente');
					setToastType('success');
					setShowToast(true);
				})
				.catch((error) => {
					setToastMsg('El servicio no se ha podido activar');
					setToastType('error');
					setShowToast(true);
				});
		} else {
			let data = {
				estado: 'inactivo',
				servicio_id: servicio,
				sede_id: serviciosSedes[0].sede_id,
			};
			axios({
				method: 'put',
				url: window.ipdirection + 'Servicio_Empresa_SedePrestador_Estado/' + servicio + '/',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: data,
			})
				.then((response) => {
					setModalActivarDesactivar(false);
					//get_Servicio_Empresa_Activo();
					//setServiciosSedes('');
					seleccionarSede(sedeId, 'activo')
					setToastMsg('Servicio desactivado correctamente');
					setToastType('success');
					setShowToast(true);
				})
				.catch((error) => {
					setToastMsg('El servicio no se ha podido desactivar');
					setToastType('error');
					setShowToast(true);
				});
		}
	};

	const [showModalEliminarServicio, setShowModalEliminarServicio] = useState(false)

	const eliminarServicio = async () => {
		let data = {
			servicio_id: servicio,
			sede_id: serviciosSedes[0].sede_id,
		}
		await axios({
			method: 'DELETE',
			url: window.ipdirection + 'Servicio_Empresa_SedePrestador_Estado/' + servicio + '/',
			headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			data: data,
		}).then((response)=>{
			setShowModalEliminarServicio(false)
			seleccionarSede(sedeId, response.data.estado)
			setToastMsg(response.data.message);
			setToastType('success');
			setShowToast(true);
		})
	}

	const [showModalModificarServicio, setShowModalModificarServicio] = useState(false)

	const anadirPeriodo = (id, nombre) => {
			// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
			let serv = {...servicio};
	
			// Recorremos cada día en el horario del servicio.
			serv.horario.map((dia) => {
				// Verificamos si el nombre del día coincide.
				if (nombre === dia.nombre) {
					// Generamos un nuevo periodo y lo añadimos al final de los periodos existentes.
					dia.periodos.push({
						id: dia.periodos[dia.periodos.length - 1].id + 1,
						hora_inicio: sumarMinuto(dia.periodos[dia.periodos.length - 1].hora_fin),
						hora_fin: sumarMinuto(
							sumarUnaHora(dia.periodos[dia.periodos.length - 1].hora_fin)
						),
						solapamiento: false,
					});
				}
			});
	
			// Actualizamos el servicio seleccionado con los cambios realizados.
			setServicio({...serv});
		};

	const borrarPeriodo = (id, nombre, per_id) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...servicio};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide y si tiene más de un periodo.
			if (nombre === dia.nombre && dia.periodos.length > 1) {
				// Eliminamos el último periodo del día usando el método pop().
				dia.periodos.pop();
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicio({...serv});
	};

	const cambiarHora = (id, nombre, per_id, init_fin, event) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...servicio};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Recorremos cada periodo en el día.
				dia.periodos.map((periodo) => {
					// Verificamos si el ID del periodo coincide.
					if (per_id === periodo.id) {
						// Actualizamos la hora de inicio o fin del periodo según el valor de init_fin.
						if (init_fin) {
							periodo.hora_inicio = event.target.value;
						} else {
							periodo.hora_fin = event.target.value;
						}
					}
				});
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicio({...serv});
	};

	const changeServicioHorarioDiaEstado = (id, nombre) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...servicio};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Cambiamos el estado del día invirtiendo su valor actual.
				dia.estado = !dia.estado;
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicio({...serv});
	};

	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */

	const modificarServicio = () => {
		let data = {
			prestadorServicios_id: Usuario.prestadorServicios.id,
			servicio_id: servicio.servicio_id.id,
			servicio_empresa_id: servicio.id,
			precioMin: servicio.precioMin,
			horasMin: servicio.horasMin,
			descripcion: servicio.descripcion,
			shareCare: servicio.shareCare,
			domicilio: servicio.domicilio,
			sedes: servicio.sedes,
			estado: estado,
		};

		axios({
			method: 'PUT',
			url: window.ipdirection + 'servicioEmpresa/' + servicio.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		}).then((response)=>{
			enviarPeriodos(servicio.id)
		})
	}

	const enviarPeriodos = (servicio_id_id) => {
		let periodosTotales = [];

		servicio.horario.forEach((dia) => {
			if (dia.estado) {
				dia.periodos.forEach((per) => {
					periodosTotales.push({
						hora_inicio: per.hora_inicio,
						hora_fin: per.hora_fin,
						servicio_empresa: servicio_id_id,
						nombre: dia.nombre,
					});
				});
			}
		});
		
		axios({
			method: 'PUT',
			url: window.ipdirection + 'periodoServicioEmpresa/'+ servicio_id_id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: periodosTotales,
		})
		.then((response) => {
			seleccionarSede(sedeId, estado)
			setShowModalModificarServicio(false)
			setToastMsg(response.data.message);
			setToastType('success');
			setShowToast(true);
		})
		.catch((error) => {
			seleccionarSede(sedeId, estado)
			setShowModalModificarServicio(false)
			setToastMsg(error.data.error);
			setToastType('error');
			setShowToast(true);
		});
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={4}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='derContentPresupuestos'>
				<SuperiroCategoriasEmpresa
					TipoNotificaciones={TipoNotificaciones}
					cambioNotificaciones={cambioNotificaciones}
				/>
				{TipoNotificaciones[0] === 'buttonNotificacionesActive' ? (
					<CatServActivos
						Categorias={Categorias}
						Servicios={Servicios}
						setActivar={setActivar}
						setServicio={setServicio}
						setModalActivarDesactivar={setModalActivarDesactivar}
						Usuario={Usuario}
						sedeId={sedeId}
						setSedeId={setSedeId}
						sedes={sedes}
						get_sedes={get_sedes}
						seleccionarSede={seleccionarSede}
						setServiciosSedes={setServiciosSedes}
						serviciosSedes={serviciosSedes}
						setShowModalEliminarServicio={setShowModalEliminarServicio}
						setShowModalModificarServicio={setShowModalModificarServicio}
						estado={estado}
						setEstado={setEstado}
					/>
				) : TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
					<CatServInactivos
						Usuario={Usuario}
						Categorias={Categorias}
						ServiciosInactivo={ServiciosInactivo}
						setActivar={setActivar}
						sedes={sedes}
						setServicio={setServicio}
						setModalActivarDesactivar={setModalActivarDesactivar}
						sedeId={sedeId}
						setSedeId={setSedeId}
						seleccionarSede={seleccionarSede}
						setServiciosSedes={setServiciosSedes}
						serviciosSedes={serviciosSedes}
						setShowModalEliminarServicio={setShowModalEliminarServicio}
						setShowModalModificarServicio={setShowModalModificarServicio}
						estado={estado}
						setEstado={setEstado}
					/>
				) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
					<CatServPendientes
						CategoriasPendientes={CategoriasPendientes}
						ServiciosPendientes={ServiciosPendientes}
						Categorias={Categorias}
					/>
				) : (
					TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
						<CatServAñadir sedes={sedes} />
					)
				)}
			</div>
			{/* <ModalPerido

			/> */}
			<M
				centered={true}
				show={modalActivarDesactivar}
			>
				<M.Header>
					<div className='titulo-modal'>
						{activar ? '¿Desea activar el servicio?' : '¿Desea desactivar el servicio?'}
					</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						{activar
							? 'Este servicio aparecerá en su lista de servicios activos'
							: 'Este servicio aparecerá en su lista de servicios inactivos'}
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn btn-outline-danger'
							onClick={() => setModalActivarDesactivar(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn login-boton'
							onClick={() => activarDesactivarServicios()}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<M
				centered={true}
				show={showModalEliminarServicio}
			>
				<M.Header>
					<div className='titulo-modal'>
						<h4>Eliminar servicio</h4>
					</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						¿Está seguro de que desea eliminar este servicio?
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn outline-boton'
							onClick={() => setShowModalEliminarServicio(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn btn-danger'
							onClick={() => eliminarServicio()}
						>
							<b>Eliminar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<M
				centered={true}
				show={showModalModificarServicio}
			>
				<M.Header>
					<div className='titulo-modal'>
						<h4>Modificar servicio</h4>
					</div>
				</M.Header>
				<M.Body>
					<div className='px-3 flex flex-column gap-2'>
						<h6 className='fw-semibold'>
							{servicio?.servicio_id?.nombre} - {servicio?.servicio_id?.categoria_id?.nombre}
						</h6>
						
						<div className='my-2'>
							<label className='form-label fw-semibold d-flex align-items-center gap-1'>
							Duración (min):
							<span className='text-danger'>
								<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='currentColor' viewBox='0 0 16 16'>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
								</svg>
							</span>
							</label>
							<Dropdown
								options={['10', '20', '30', '45', '60', '90', '120']}
								value={servicio?.horasMin?.toString()}
								onChange={(e)=>setServicio({...servicio, horasMin: parseInt(e.value)})}
							/>
						</div>

						
						<div className='my-2'>
							<label className='form-label fw-semibold d-flex align-items-center gap-1'>
								Precio (€):
								<span className='text-danger'>
									<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='currentColor' viewBox='0 0 16 16'>
									<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</span>
							</label>
							<input
								type='number'
								className='form-control text-black'
								placeholder='Ej. 25'
								value={servicio?.precioMin}
								onChange={(e)=>setServicio({...servicio, precioMin: e.target.value})}
							/>
						</div>

						
						<div className='my-2'>
							<label className='form-label fw-semibold d-flex align-items-center gap-1'>
							Sedes en las que está disponible este servicio:
							<span className='text-danger'>
								<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='currentColor' viewBox='0 0 16 16'>
								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
								</svg>
							</span>
							</label>

							<div className='d-flex flex-column gap-2'>
							{sedes?.map((sede, index) => (
								<div className='form-check' key={sede.id}>
								<Form.Check
									id={sede.id}
									onChange={(e) => {
										const checked = e.target.checked;
										const sedeId = sede.id;

										if (checked) {
											setServicio({
												...servicio,
												sedes: [...servicio.sedes, sedeId],
											});
										} else {
											setServicio({
												...servicio,
												sedes: servicio.sedes.filter((id) => id !== sedeId),
											});
										}
									}}
									checked={servicio?.sedes?.includes(sede?.id)}
								/>
								<label className='form-check-label' htmlFor={sede?.id}>
									{sede?.nombreSede}
								</label>
								</div>
							))}
							</div>
						</div>

						<div className='centrador'>
							<button
								type="button"
								className="d-flex align-items-center gap-2 btn login-boton px-3 py-2 shadow-sm"
								onClick={() => {setModalPeriodo(true)}}
							>
								<i className="bi bi-calendar2-week-fill fs-5"></i>
								<span className="fw-medium">Seleccionar Horario</span>
							</button>
						</div>
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn outline-boton'
							onClick={() => setShowModalModificarServicio(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn login-boton'
							onClick={modificarServicio}
						>
							<b>Guardar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<ModalPerido
				ModalPer={ModalPeriodo}
				setModalPer={setModalPeriodo}
				servicio={servicio}
				changeServicioHorarioDiaEstado={changeServicioHorarioDiaEstado}
				cambiarHora={cambiarHora}
				anadirPeriodo={anadirPeriodo}
				borrarPeriodo={borrarPeriodo}
			/>

			<ToastNotification 
				message={toastMsg}
				show={showToast}
				onClose={() => setShowToast(false)}
				type={toastType}
			/>
		</>
	);
};

// <Solicitar />
